module.exports = __webpack_public_path__ + "static/media/TN-Women-Knits-2.0-OptionAll.3b82a488.svg";